import React from 'react';
import { Form, FormGroup, Col, Row, FormControl, ControlLabel, Button, Alert, Label } from 'react-bootstrap';
import { withRouter, Link } from 'react-router-dom';

import queryString from 'query-string';
import axios from 'axios';
import classNames from 'classnames';
import constants from '../util/constants';

import NPPanel from '../NPPanel';

const { API_BASE_URL } = constants;

class ResetPassword extends React.Component {
  constructor(props) {
    super(props);

    this.passwordsMatch = this.passwordsMatch.bind(this);
    this.postResetPassword = this.postResetPassword.bind(this);

    this.state = {
      password: null,
      repeatedPassword: null,
      passwordFieldDirty: false,
      repeatedPasswordFieldDirty: false,
      showPasswordResetSuccessful: false,
      showPasswordResetFailed: false,
    }
  }

  passwordsMatch() {
    const { password, repeatedPassword } = this.state;

    if(password && repeatedPassword) {
      return password === repeatedPassword;
    } else {
      return false;
    }
  }

  postResetPassword() {
    const { userId, code } = queryString.parse(this.props.location.search);
    const self = this;

    let path = 'Account/ConfirmResetPassword?userId=' + encodeURIComponent(userId) + '&code=' + encodeURIComponent(code);

    axios.post(API_BASE_URL + path, {
      NewPassword: this.state.password,
      ConfirmPassword: this.state.repeatedPassword,
    })
    .then(function (response) {
      self.setState({
        showPasswordResetSuccessful: true,
        showPasswordResetFailed: false,
      });
    })
    .catch(function (error) {
      self.setState({
        showPasswordResetSuccessful: false,
        showPasswordResetFailed: true,
      });
    });
  }

  render() {
    const passwordsMatch = this.passwordsMatch();
    const fieldsDirty = this.state.passwordFieldDirty && this.state.repeatedPasswordFieldDirty;
    const passwordFieldClassNames = fieldsDirty ? classNames({ success: passwordsMatch, error: !passwordsMatch }) : null;
    const { showPasswordResetSuccessful, showPasswordResetFailed } = this.state;

    return (<NPPanel title="Reset password" small centered>
      {showPasswordResetSuccessful && <Alert bsStyle="success">
            <p>Password has been reset successfully. <Link style={{color: 'black'}} to="/login" className="text-white">Click here to login.</Link></p>
      </Alert>}

      {showPasswordResetFailed && <Alert bsStyle="danger"><p>Password has not been reset, please try again.</p></Alert>}   
      <Form horizontal autoComplete="off" onSubmit={evt => { evt.preventDefault(); this.postResetPassword() }}>
        <div>
        <Row>
          <Col smOffset={2} sm={10}>
            <Label bsStyle="primary">Password must be at least 8 characters of length and contain at least one digit.</Label>
          </Col>
        </Row>
        <FormGroup validationState={passwordFieldClassNames} controlId="formHorizontalNewPassword">
          <Col componentClass={ControlLabel} sm={2}>
            New password
          </Col>
          <Col sm={10}>
            <FormControl type="password" placeholder="New password" onChange={evt => { this.setState({ passwordFieldDirty: true, password: evt.target.value }) }} />
          </Col>
        </FormGroup>
        <FormGroup validationState={passwordFieldClassNames} controlId="formHorizontalRepeatPassword">
          <Col componentClass={ControlLabel} sm={2}>
            Repeat password
          </Col>
          <Col sm={10}>
            <FormControl type="password" placeholder="Repeat password" onChange={evt => { this.setState({ repeatedPasswordFieldDirty: true, repeatedPassword: evt.target.value }) }} />
          </Col>
        </FormGroup>
        <FormGroup>
          <Col smOffset={2} sm={10}>
            <Button type="button" bsStyle="primary" disabled={!passwordsMatch} onClick={this.postResetPassword}>
              Change password
            </Button>
          </Col>
        </FormGroup>
        </div>
      </Form>
    </NPPanel>)
  }
}

export default withRouter(ResetPassword);